module.exports = __webpack_public_path__ + "static/media/20_g_neg.cb9fd8bc.pdf";